import { CredentialResponse, GoogleLogin } from '@react-oauth/google';
import { useTranslation } from 'react-i18next';
import { showDefaultErrorToast } from '@app/utils';
import { useGoogleSignUp } from '@data/hooks';
import { useB2BSignUpFormStore } from '@data/storage';

type GoogleSignUpButtonProps = {
  width: number;
};

export const GoogleSignUpButton = ({ width }: GoogleSignUpButtonProps) => {
  const { setFormStep } = useB2BSignUpFormStore();

  const {
    i18n: { language },
  } = useTranslation();

  const { mutate } = useGoogleSignUp();

  const googleSignUp = async (response: CredentialResponse) => {
    const { credential: idToken } = response;
    if (!idToken) return;

    mutate(
      { idToken },
      {
        onSuccess: () => {
          setFormStep(1);
        },
        onError: (err) => {
          showDefaultErrorToast(err);
        },
      },
    );
  };

  return (
    <GoogleLogin
      size="large"
      onSuccess={googleSignUp}
      text="continue_with"
      locale={language}
      width={width}
      shape="pill"
    />
  );
};
